module.exports = __webpack_public_path__ + "static/media/PMG-Project.Proponent.Private.Manual.b7ad4995.pdf";